import { useCurrentProduct, useCurrentTenant, useGet } from "@drift/oneplatfront-components";
import { useEffect, useState } from "react";

import DashboardDto from "../dto/DashboardDto";

type useGetDashboardFromPowerboardType = () => {
    powerboard: DashboardDto | null;
    loading: boolean;
    error: any;
};

export { useGetDashboardFromPowerboardType };

export const useGetDashboardFromPowerboard: useGetDashboardFromPowerboardType = () => {
    const [started, setStarted] = useState(false);

    const { product } = useCurrentProduct(true);
    const { tenant } = useCurrentTenant(true);

    const {
        data: dashboardResponse,
        loading,
        error,
        fetch,
    } = useGet(`driftBffApi://v1/dashboard?productId=${product?.id}`, {
        lazy: true,
    });

    useEffect(() => {
        if (!!product && !!tenant) {
            fetch();
            setStarted(true);
        }
    }, [product?.id, tenant?.id]);

    const data =
        product && !loading && !error && dashboardResponse && dashboardResponse.length > 0
            ? dashboardResponse[0]
            : null;

    return { powerboard: data, loading: !started ? true : loading, error };
};
